import React, { ReactElement } from "react";
import { FormikContextType, useFormikContext } from "formik";
import { Slider, SliderTrack, SliderFilledTrack, SliderThumb, Text, Flex, Spacer, Tooltip } from "@chakra-ui/react";
import { FieldWrapper } from "./FieldWrapper";

interface Props {
  name: string;
  color?: string;
  w?: string;
  step?: number;
  min?: number;
  max?: number;
  label?: string;
  marks?: string[];
  useTooltip?: boolean;
  customTextFunction?: () => string;
}

export function SliderField({
  name,
  w,
  step,
  min,
  max,
  label,
  marks,
  color = "monster.primary",
  useTooltip = false,
  customTextFunction,
}: Props): ReactElement {
  const formikProps = useFormikContext();

  const defaultThumbText = () => "";

  return (
    <FieldWrapper name={name} label={label} key={name + label}>
      <Slider w={w} value={formikProps.values[name]} step={step} min={min} max={max} onChange={(val) => formikProps.setFieldValue(name, val)}>
        <SliderTrack bg={"#f6f6f6"}>
          <SliderFilledTrack bg={color} />
        </SliderTrack>
        <SliderDisplay customTextFunction={customTextFunction} formikProps={formikProps} name={name} useTooltip={useTooltip} color={color} />
      </Slider>
      {marks ? <Flex>{flexChildren(name, marks)}</Flex> : null}
    </FieldWrapper>
  );
}

function SliderDisplay({ customTextFunction, formikProps, name, useTooltip = false, color }: DisplayProps): ReactElement {
  if (useTooltip) {
    return (
      <Tooltip bg={color} placement="top" label={customTextFunction ? customTextFunction() : formikProps.values[name]} fontSize="1.2rem">
        <SliderThumb color={color} _focus={{ outline: `2px solid ${color}` }}>
          <Text fontSize=".9rem" size="lg" color={"black"} fontFamily="linotte">
            {formikProps.values[name]}
            {/* {customTextFunction ? customTextFunction() : formikProps.values[name]} */}
          </Text>
        </SliderThumb>
      </Tooltip>
    );
  } else {
    return (
      <SliderThumb _focus={{ outline: `2px solid ${color}` }}>
        <Text fontSize=".9rem" size="lg" color={"black"} fontFamily="linotte">
          {customTextFunction ? customTextFunction() : formikProps.values[name]}
        </Text>
      </SliderThumb>
    );
  }
}

interface DisplayProps {
  customTextFunction: () => string;
  formikProps: FormikContextType<any>;
  name: string;
  useTooltip?: boolean;
  color: string;
}

const flexChildren = (name: string, labels: string[]): ReactElement[] => {
  const children: ReactElement[] = [];
  labels.forEach((label) => {
    children.push(<Text key={`Text ${name} ${label}`}>{label}</Text>);
    children.push(<Spacer key={`Spacer ${name} ${label}`} />);
  });
  children.pop();
  return children;
};
